// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3ddin","label":"Radio_label__2nkjT","checkMark":"Radio_checkMark__3jMQD","disabled":"Radio_disabled__2WWcq"};